<template>
	<BaseModal
		class="country-switcher-modal"
		:title="$t('WEBAPP_ACCOUNTMODAL_MAIN_COUNTRY')"
		@dismiss="$emit('dismiss')"
	>
		<div class="country-switcher-modal-content">
			<div key="country">
				<CountryList @selected-country="closeSelf" :additionalContexts="additionalContexts" />
			</div>
		</div>
	</BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/modals/vfm/BaseModal.vue';
import CountryList from '@/features/buybox/components/CountryList.vue';
import { SnowplowContext } from '@/helpers/tracking/providers';
import { VFMHelper } from '@/helpers/vfm/vfm-helper';

const props = defineProps<{
	countrySelectedCallback?: (() => void) | null;
	additionalContexts?: SnowplowContext[];
}>();

async function closeSelf() {
	props.countrySelectedCallback?.();
	VFMHelper.close();
}
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.country-switcher-modal {
	.text-light {
		color: #989998;
		font-weight: normal;
		font-size: 15px;
	}

	.mt {
		margin-top: 15px;
	}

	&__header-description {
		color: $jw-color-mediumgray--light;
		font-size: 18px;
		letter-spacing: 0.3px;
		line-height: 26px;
	}
}

.country-switcher-modal-content {
	padding: 0 35px 35px;

	.mb {
		margin-bottom: 15px;
	}
}
</style>
